import { UpOutlined, DownOutlined, EyeInvisibleOutlined, EyeOutlined, SketchOutlined, FireOutlined, PoweroffOutlined } from '@ant-design/icons';
import { Space, Tag, Input, Button } from 'antd';
import { StoryFramesModel } from 'interface/models';
import { StoryController_createOneFrame, StoryController_removeFrame } from '../StoryBoard/createOneFrame';
import gql from 'graphql-tag';
import { useAuthedMutation } from 'utils/qlAuth';
import { useState } from 'react';
import { TimelinePlan_EditFrame } from '../TimelinePlan/TimelinePlan_EditFrame';

const FrameReactions = (props: { current: StoryFramesModel }) => {
  const current = props.current;
  const [updateFrame] = useAuthedMutation(
    gql`
      mutation StoryController_updateFrame($frameId: Int!, $input: JSON!) {
        StoryController_updateFrame(frameId: $frameId, config: $input) {
          id
        }
      }
    `,
  );
  const [reactions, setReactions] = useState(current.reactions || []);
  const ui = {
    fire: <FireOutlined />,
  };

  return (
    <Space direction="horizontal">
      {Object.keys(ui).map(uiIcoName => {
        return (
          <Button
            key={uiIcoName}
            title="Реакции на видео"
            size="small"
            type={reactions.includes(uiIcoName) ? 'primary' : 'default'}
            onClick={async () => {
              let newValue = [];
              if (reactions.includes(uiIcoName)) {
                newValue = reactions.filter(v => v != uiIcoName);
              } else {
                newValue = [...reactions, uiIcoName];
              }

              setReactions(newValue);
              updateFrame({
                variables: {
                  frameId: current.id,
                  input: { reactions: newValue },
                },
              });
            }}
          >
            {ui[uiIcoName]}
          </Button>
        );
      })}
    </Space>
  );
};

export const FrameHeader = (props: {
  current: StoryFramesModel;
  prev: StoryFramesModel;
  next: StoryFramesModel;
  setNewTimeStart: (id: number, value: number) => void;
  onChange: (frame: StoryFramesModel) => void;
  qFrames: any;
  storyId: number;
  displayType?: 'text' | 'image' | string;
  onReload: () => void;
}) => {
  const { prev, next, current, setNewTimeStart, qFrames, storyId } = props;

  const [updateFrame] = useAuthedMutation(
    gql`
      mutation StoryController_updateFrame($frameId: Int!, $input: JSON!) {
        StoryController_updateFrame(frameId: $frameId, config: $input) {
          id
        }
      }
    `,
  );

  const addTimeStart = Math.floor(current.timeStart + ((next?.timeStart || current.timeStart) - (current.timeStart || 0) + 1) / 2);
  return (
    <Space
      direction="horizontal"
      key={current.id}
      style={{
        marginBottom: 6,
      }}
    >
      <TimelinePlan_EditFrame frame={current} storyId={props.storyId} displayType={props.displayType} onReload={props.onReload} />
      <Tag>Id={current.id}</Tag>
      <span>Time Start: </span>
      <Input
        size="small"
        key={current.id + '-' + current.timeStart}
        type="number"
        defaultValue={current.timeStart || 0}
        onBlur={e => setNewTimeStart(current.id, Number(e.target.value))}
        style={{ width: '80px' }}
      />
      {/* - {current.timeLength} */}
      <Tag
        key={current.id + `up`}
        title="Move up"
        onClick={() => {
          if (prev) {
            const tTime = current.timeStart;
            current.timeStart = prev.timeStart;
            prev.timeStart = tTime;
            setNewTimeStart(current.id, Number(current.timeStart));
            setNewTimeStart(prev.id, Number(prev.timeStart));
          }
        }}
      >
        <UpOutlined />
      </Tag>
      <Tag
        key={current.id + `down`}
        title="Move down"
        onClick={() => {
          if (next) {
            const tTime = current.timeStart;
            current.timeStart = next.timeStart;
            next.timeStart = tTime;
            setNewTimeStart(current.id, Number(current.timeStart));
            setNewTimeStart(next.id, Number(next.timeStart));
          }
        }}
      >
        <DownOutlined />
      </Tag>
      <StoryController_createOneFrame
        key={current.id + `createOneFrame`}
        storyId={Number(storyId)}
        frameId={Number(current.id)}
        timeStart={addTimeStart}
        onAdd={() => {
          qFrames.refetch();
        }}
      />
      <StoryController_removeFrame
        key={current.id + `removeFrame`}
        frameId={current.id}
        onRemove={(frameId: number) => {
          qFrames.refetch();
        }}
      />
      <Button
        size="small"
        onClick={async () => {
          props.onChange({ ...current, status: `like` });
          updateFrame({
            variables: {
              frameId: current.id,
              input: { status: `like` },
            },
          });
        }}
        type={current.status === 'like' ? 'primary' : 'default'}
      >
        <SketchOutlined />
      </Button>
      <Button
        size="small"
        onClick={async () => {
          const newVal = current.status === 'hidden' ? 'shown' : 'hidden';
          props.onChange({ ...current, status: newVal });
          updateFrame({
            variables: {
              frameId: current.id,
              input: { status: newVal },
            },
          });
        }}
        type={current.status === 'hidden' ? 'primary' : 'default'}
      >
        <EyeInvisibleOutlined />
      </Button>
      <Button
        size="small"
        onClick={async () => {
          const newVal = current.status === 'skip' ? 'shown' : 'skip';
          props.onChange({ ...current, status: newVal });
          updateFrame({
            variables: {
              frameId: current.id,
              input: { status: newVal },
            },
          });
        }}
        type={current.status === 'skip' ? 'primary' : 'default'}
      >
        <PoweroffOutlined />
      </Button>
      Tags:
      {current.tags.map(tag => (
        <Tag key={tag}>{tag}</Tag>
      ))}
      <FrameReactions current={current} />{' '}
    </Space>
  );
};
